import { CoreEnv } from '@eventbrite/legacy-infra.context-types';
import { setWindowLocation } from '@eventbrite/legacy-infra.http';
import { useIntl } from 'react-intl';
import { SiteFooter } from '@eventbrite/legacy-infra.site-footer';
import type { GlobalFooterProps } from '@eventbrite/legacy-infra.site-footer/server/types';
import { LOCALE_DEFAULTS } from '@eventbrite/webapp-locales';

export interface FooterProps {
  serverUrl: string;
  localeInfo: CoreEnv['localeInfo'];
  isUserAuthenticated: boolean;
  globalFooterProps: GlobalFooterProps;
}

export function Footer({
  serverUrl,
  localeInfo,
  isUserAuthenticated,
  globalFooterProps,
}: FooterProps) {
  const {
    showMinimalLinks,
    thirdFooterColumn = [],
    popularSearches,
    eventsToPlan,
    impressumHelpLink,
  } = globalFooterProps;

  const intl = useIntl();

  const locales = LOCALE_DEFAULTS.map(({ locale, localized_language_name, locale_name }) => ({
    locale,
    localized_language_name,
    locale_name,
  }));
  const localesSorted = locales?.sort((a, b) => a.locale_name.localeCompare(b.locale_name));

  const trimmedServerUrl = serverUrl.replace(/\/$/, '');

  const handleLocaleChange = (locale: string) => {
    setWindowLocation(`${trimmedServerUrl}/international/change_locale/?locale=${locale}`);
  };

  return (
    <div data-testid="footer-section">
      <SiteFooter
        serverUrl={trimmedServerUrl}
        showMinimalLinks={showMinimalLinks}
        showMarketingLinks={!isUserAuthenticated}
        locales={localesSorted}
        localeInfo={localeInfo}
        onLocaleChange={handleLocaleChange}
        thirdFooterColumn={thirdFooterColumn || []}
        thirdFooterColumnName={intl.formatMessage({
          id: 'Find Events',
          defaultMessage: 'Find Events',
        })}
        popularSearches={popularSearches}
        eventsToPlan={eventsToPlan}
        helpLinks={{ impressum: impressumHelpLink }}
      />
    </div>
  );
}
